import { useSearchParams } from 'react-router-dom';
import { SearchForm, DailySearchForm, UserSearchForm } from '../types';

type UseSearchFormReturn = {
  updatePeriodParams: (form: SearchForm) => void;
  updateDailyParams: (form: DailySearchForm) => void;
  updateUserSearchParams: (form: UserSearchForm) => void;
  getFormFromUrl: () => { periodForm?: SearchForm; dailyForm?: DailySearchForm; userSearchForm?: UserSearchForm };
};

export const useSearchForm = (): UseSearchFormReturn => {
  const [searchParams, setSearchParams] = useSearchParams();

  const getFormFromUrl = (): { periodForm?: SearchForm; dailyForm?: DailySearchForm; userSearchForm?: UserSearchForm } => {
    const type = searchParams.get('type');
    const userId = searchParams.get('userId');
    
    if (type === 'period') {
      const startDate = searchParams.get('startDate');
      const endDate = searchParams.get('endDate');
      if (userId && startDate && endDate) {
        return { periodForm: { userId, startDate, endDate } };
      }
    } else if (type === 'daily') {
      const selectedDate = searchParams.get('selectedDate');
      if (userId && selectedDate) {
        return { dailyForm: { userId, selectedDate } };
      }
    } else if (type === 'usersearch') {
      const name = searchParams.get('name') || '';
      const email = searchParams.get('email') || '';
      const startDate = searchParams.get('startDate');
      const endDate = searchParams.get('endDate');
      if (startDate && endDate) {
        return { userSearchForm: { name, email, startDate, endDate } };
      }
    }
    return {};
  };

  const updatePeriodParams = (form: SearchForm) => {
    setSearchParams({
      type: 'period',
      userId: form.userId,
      startDate: form.startDate,
      endDate: form.endDate
    });
  };

  const updateDailyParams = (form: DailySearchForm) => {
    setSearchParams({
      type: 'daily',
      userId: form.userId,
      selectedDate: form.selectedDate
    });
  };

  const updateUserSearchParams = (form: UserSearchForm) => {
    const params: Record<string, string> = {
      type: 'usersearch',
      startDate: form.startDate,
      endDate: form.endDate
    };
    if (form.name) params.name = form.name;
    if (form.email) params.email = form.email;
    setSearchParams(params);
  };

  return {
    updatePeriodParams,
    updateDailyParams,
    updateUserSearchParams,
    getFormFromUrl,
  };
};
